import globals from "../globals";
const API_BASE = "api/Wizard";

class WizardService {
  readMasterSurveysAndProjects() {
    return $.ajax({
      method: "GET",
      url: `${API_BASE}/MasterSurveysAndProjects`,
      contentType: "application/json; charset=utf-8",
      success: (data) => {
        return data;
      },
      error: (error) => {
        console.error("Error on GET in readMasterSurveysAndProjects()", error);
        globals.showErrorSnackbar("readMasterSurveysAndProjects() failed");
      },
    });
  }
  readAgencies() {
    return $.ajax({
      method: "GET",
      url: `${API_BASE}/Agencies`,
      contentType: "application/json; charset=utf-8",
      success: (data) => {
        return data;
      },
      error: (error) => {
        console.error("Error on GET in readAgencies()", error);
        globals.showErrorSnackbar("readAgencies() failed");
      },
    });
  }
  exportConfiguration(ConfigurationGuid) {
    return $.ajax({
      method: "GET",
      url: `${API_BASE}/${ConfigurationGuid}/Export`,
      contentType: "application/json; charset=utf-8",
      success: (data) => {
        if (data.Error) {
            globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          globals.downloadFile(data[0].DownloadId);
      },
      error: (error) => {
        console.error("Error on GET in exportConfiguration()", error);
        globals.showErrorSnackbar("exportConfiguration() failed");
      },
    });
  } 
  readImporters() {
    return $.ajax({
      method: "GET",
      url: `${API_BASE}/Importers`,
      contentType: "application/json; charset=utf-8",
      success: (data) => {
        return data;
      },
      error: (error) => {
        console.error("Error on GET in readImporters()", error);
        globals.showErrorSnackbar("readImporters() failed");
      },
    });
  }
  readScenarios(configurationGuid) {
    return $.ajax({
      method: "GET",
      url: `${API_BASE}/Scenarios/${configurationGuid}`,
      contentType: "application/json; charset=utf-8",
      success: (data) => {
        return data;        
      },
      error: (error) => {
        console.error("Error on GET in readScenarios()", error);
        globals.showErrorSnackbar("readScenarios() failed");
      },
    });
  }
  readCarModel() {
    return $.ajax({
      method: "GET",
      url: "api/CarModel",
      contentType: "application/json; charset=utf-8",
      success: (data) => {
        return data;        
      },
      error: (error) => {
        console.error("Error on GET in readCarModel()", error);
        globals.showErrorSnackbar("readCarModel() failed");
      },
    });
  }
  readCarSegment() {
    return $.ajax({
      method: "GET",
      url: "api/CarModel/CarSegment",
      contentType: "application/json; charset=utf-8",
      success: (data) => {
        return data;        
      },
      error: (error) => {
        console.error("Error on GET in readCarSegment()", error);
        globals.showErrorSnackbar("readCarSegment() failed");
      },
    });
  }
  readConfigurations() {
    return $.ajax({
      method: "GET",
      url: `${API_BASE}/Configurations`,
      contentType: "application/json; charset=utf-8",
      success: (data) => {
        return data;
      },
      error: (error) => {
        console.error("Error on GET in readConfigurations()", error);
        globals.showErrorSnackbar("readConfigurations() failed");
      },
    });
  }
  readConfiguration(configurationGuid) {
    return $.ajax({
      method: "GET",
      url: `${API_BASE}/Configuration/${configurationGuid}`,
      contentType: "application/json; charset=utf-8",
      success: (data) => {
        return data;
      },
      error: (error) => {
        console.error("Error on GET in readConfiguration()", error);
        globals.showErrorSnackbar("readConfiguration() failed");
      },
    });
  }
  saveConfiguration(config) {
    return $.ajax({
      method: "POST",
      url: `${API_BASE}/Configuration`,
      data: JSON.stringify(config),
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      success: (data) => {
        return data;
      },
      error: (error) => {
        console.error("Error on POST in saveConfiguration()", error);
        globals.showErrorSnackbar("saveConfiguration() failed");
      },
    });
  }
  readBrandsOfConfiguration(configurationGuid) {
    return $.ajax({
      method: "GET",
      url: `/api/Wizard/Brands/${configurationGuid}`,
      success: (data) => {
        return data;
      },
      error: () => {
        console.error("Error on GET in readBrandsOfConfiguration()");
        globals.showErrorSnackbar("read Brands failed");
      },
    });
  }
  readConfigurationLocations(configurationGuid) {
    return $.ajax({
      method: "GET",
      url: `${API_BASE}/ConfigurationLocations/${configurationGuid}`,
      contentType: "application/json; charset=utf-8",
      success: (data) => {
        return data;
      },
      error: (error) => {
        console.error("Error on GET in readConfigurationLocations()", error);
        globals.showErrorSnackbar("readConfigurationLocations() failed");
      },
    });
  }
  deleteConfiguration(configurationGuid) {
    return $.ajax({
      method: "DELETE",
      url: `${API_BASE}/${configurationGuid}`,
      contentType: "application/json; charset=utf-8",
      success: (data) => {
        return data;
      },
      error: (error) => {
        console.error("Error on DELETE in deleteConfiguration()", error);
        globals.showErrorSnackbar("deleteConfiguration() failed");
      },
    });
  }
  getProjectAttachments(configurationGuid) {
    return $.ajax({
      method: "GET",
      url: `/api/data/ProjectAttachments/${configurationGuid}`,
      success: (data) => {
        return data;
      },
      error: () => {
        console.error("Attachments data access failed in getProjectAttachments()");
        globals.showErrorSnackbar(this.lang.CM2043);
      },
    });
  }
  createElementsFromConfiguration(configurationGuid) {
    return $.ajax({
      method: "POST",
      url: `${API_BASE}/CreateElementsFromConfiguration`,
      data: configurationGuid,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      success: (data) => {
        return data;
      },
      error: () => {
        console.error("Create elements from configuration failed.");
        globals.showErrorSnackbar("createElementsFromConfiguration() failed");
      },
    });
  }
  updateConfigurationStatus(configurationGuid, targetStatus) {
    return $.ajax({
      method: "POST",
      url: `${API_BASE}/${configurationGuid}/${targetStatus}`,
      success: (data) => {
        return data;
      },
      error: () => {
        console.error("Update configuration status failed in updateConfigurationStatus()");
        globals.showErrorSnackbar("updateConfigurationStatus() failed");
      },
    });
  }
  addProjectAttachment(projectGuid, downloadId, attachmentType) {
    return $.ajax({
      method: "POST",
      url: `${API_BASE}/ProjectAttachment/${projectGuid}/${downloadId}/${attachmentType}`,
      success: (data) => {
        return data;
      },
      error: () => {
        console.error("Add ProjectAttachment failed");
        globals.showErrorSnackbar("addProjectAttachment() failed");
      },
    });
  }
  getMasterSurvey(configurationGuid) {
    return $.ajax({
      method: "GET",
      url: `/api/Wizard/MasterSurvey/${configurationGuid}`,
      success: (data) => {
        return data;
      },
      error: () => {
        console.error("Get master survey failed in getMasterSurvey()");
        globals.showErrorSnackbar("Get master survey failed");
      },
    });
  }
}

export default new WizardService();



// WEBPACK FOOTER //
// ./src/services/WizardService.js